import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Customer Documents ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" select file ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" upload ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Documents List")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_typography_paragraph = _resolveComponent("el-typography-paragraph")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: "paperclip",
            class: "el-text__primary"
          }),
          _hoisted_1
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              ref: "uploadRef",
              limit: 1,
              "auto-upload": false,
              "on-change": _ctx.onChange
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_el_button, { block: "" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_ctx.fileName)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "success",
                      onClick: _ctx.saveDocument
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["on-change"])
          ]),
          _: 1
        }),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_el_typography_paragraph, null, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "paperclip",
                  class: "el-text__primary"
                }),
                _createTextVNode(" " + _toDisplayString(document.createdAt) + " - " + _toDisplayString(document.createdBy?.email) + " - " + _toDisplayString(document.fileName) + "   ", 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": "Yes",
              "cancel-button-text": "No",
              title: "Are you sure to delete this?",
              onConfirm: ($event: any) => (_ctx.removeDocument(Number(document.id)))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, { type: "text" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "trash-alt",
                      class: "el-text__danger"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"]),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (_ctx.downloadDocument({ documentId: Number(document.id), fileName: document.fileName}))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "download",
                  class: "el-text__primary"
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_divider)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}